import Structure from '../modules/structure';

$.fn.commonSwiperSlider = function(options) {

    var jqAllAffectedContainers = this;

    jqAllAffectedContainers.each(function() {
        const container = $(this);
        const structure = new Structure('commonSwiperSlider', container, {
            slider: ".common-swiper-container",
            nav: ".swiper-pagination",
            nextSlide: ".swiper-button-next",
            prevSlide: ".swiper-button-prev"
        }).structure;

        const defaultOptions = {
            slidesPerView: 4,
            spaceBetween: 30,
            navigation: {
                nextEl: structure.nextSlide.get(0),
                prevEl: structure.prevSlide.get(0),
            },
            pagination: {
                el: structure.nav.get(0),
                clickable: true
            },
            breakpoints: {
                320: {
                    slidesPerView: 'auto',
                },
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                },
                1540: {
                    slidesPerView: 4,
                }
            },
        }

        // init Swiper:

        const concatOptions = { ...defaultOptions, ...options};

        const sliderObj = new Swiper(structure.slider.get(0), concatOptions);
    });

    return this;
};

document.addEventListener('DOMContentLoaded', function() {
    $('.common-swiper-slider-js').commonSwiperSlider({
        slidesPerView: 3,
        spaceBetween: 30,
        breakpoints: {
            320: {
                slidesPerView: 'auto',
            },
            768: {
                slidesPerView: 1,
            },
            1200: {
                slidesPerView: 2,
            },
            1540: {
                slidesPerView: 3,
            }
        },
    });
    $('.catalog-items-slider-js').commonSwiperSlider({
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
            320: {
                
            },
            768: {
                
            },
            1200: {
                
            },
            1540: {
                
            }
        },
    });
    $('.gallery-slider-js').commonSwiperSlider({
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            1200: {
                
            },
            1540: {
                
            }
        },
    });
    $('.gallery-simple-slider-js').commonSwiperSlider({
        slidesPerView: 2,
        spaceBetween: 16,
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 8,
            },
            1200: {
                
            },
            1540: {
                
            }
        },
    });
    $('.article-gallery-js').commonSwiperSlider({
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        breakpoints: {
            320: {
                
            },
            768: {
                
            },
            1200: {
                
            },
            1540: {
                
            }
        },
    });
    $('.brands-slider-js').commonSwiperSlider({
        slidesPerView: 7,
        spaceBetween: 16,
        breakpoints: {
            320: {
                slidesPerView: 'auto',
            },
            768: {
                slidesPerView: 'auto',
            },
            1279: {
                slidesPerView: 7,
            },
            1540: {
                
            }
        },
    });
    $('.categories-slider-js').commonSwiperSlider({
        slidesPerView: 7,
        spaceBetween: 8,
        breakpoints: {
            320: {
                slidesPerView: 'auto',
            },
            768: {
                slidesPerView: 'auto',
            },
            1200: {
                
            },
            1540: {
                
            }
        },
    });
    $('.categories-slider-simple-js').commonSwiperSlider({
        slidesPerView: 'auto',
        spaceBetween: 2,
        breakpoints: {
            320: {
                
            },
            768: {
                
            },
            1200: {
                
            },
            1540: {
                
            }
        },
    });
});
